import React, { useEffect, useState } from 'react';

import { Link, useParams } from 'react-router-dom';



const Inventory = () => {


     const { inventoryId } = useParams()
     const [service, setService] = useState([]);
     const [num, setNum] = useState(4);


     useEffect(() => {
          const url = `https://secure-springs-71035.herokuapp.com/service/${inventoryId}`;

          fetch(url)
               .then(res => res.json())
               .then(data => setService(data));
     }, [])






     const handlePlus = () => {
          setNum(num + 1)

     }

     const handleMinus = () => {
          if (num > 0) {
               setNum(num - 1)

          } else {
               setNum(0)
          }
     }










     return (
          <div className='py-4 '>
               <h3 className='text-center text-primary fw-bold pb-3'>This is Inventory Page</h3>
               <div className="card mb-3" >
                    <div className="row g-0">
                         <div className="col-md-6">
                              <img src={service.img} className="img-fluid rounded-start h-100 p-2" alt="..." />
                         </div>
                         <div className="col-md-6">
                              <div className="card-body">
                                   <h5 className="card-title">{service.name}</h5>
                                   <p className="card-text">{service.description}</p>

                                   <p className="card-text">Price: {service.price}</p>

                              </div>

                              <h3>Quantity : {num}</h3>



                              <button onClick={() => handlePlus()} className='btn  me-3 fw-bold
                          
                              btn-primary'> ADD QUANTITY</button>
                              <button onClick={handleMinus} className='btn  fw-bold btn-primary'>DELIVAR QUANTITY</button>
                         </div>
                    </div>
               </div>
               <Link to='/manageCar'>
                    <button className='btn btn-primary fw-bold p-2'>MANAGE CAR 🡲</button>
               </Link>

          </div>
     );
};

export default Inventory;